import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { initSentry } from '@/lib/sentry'
import { registerServiceWorker } from '@/utils/registerServiceWorker'

// Initialize Sentry before rendering the app
// Extra try-catch for safety - ensures app renders even if Sentry completely fails
try {
  initSentry();
} catch (error) {
  console.warn('Sentry initialization failed at entry point:', error);
}

registerServiceWorker();

createRoot(document.getElementById("root")!).render(<App />);
